import { render, staticRenderFns } from "./MessageBell.vue?vue&type=template&id=229b236f&scoped=true"
import script from "./MessageBell.vue?vue&type=script&lang=js"
export * from "./MessageBell.vue?vue&type=script&lang=js"
import style0 from "./MessageBell.vue?vue&type=style&index=0&id=229b236f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229b236f",
  null
  
)

export default component.exports